import { render, staticRenderFns } from "./AssignmentList.vue?vue&type=template&id=170c93ec&scoped=true&"
import script from "./AssignmentList.vue?vue&type=script&lang=js&"
export * from "./AssignmentList.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentList.vue?vue&type=style&index=0&id=170c93ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170c93ec",
  null
  
)

export default component.exports